/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./EndTempReassignmentConfirmDialog.vue?vue&type=template&id=4c7ad95a"
import script from "./EndTempReassignmentConfirmDialog.vue?vue&type=script&lang=js"
export * from "./EndTempReassignmentConfirmDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c7ad95a')) {
      api.createRecord('4c7ad95a', component.options)
    } else {
      api.reload('4c7ad95a', component.options)
    }
    module.hot.accept("./EndTempReassignmentConfirmDialog.vue?vue&type=template&id=4c7ad95a", function () {
      api.rerender('4c7ad95a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/patients/EndTempReassignmentConfirmDialog.vue"
export default component.exports